import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceGroup } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import {
  GetServiceGroupsFromServer,
  GetServiceGroupsFromServerSuccess,
  ServiceGroupsEntityActionTypes
} from './service-groups.actions';

@Injectable()
export class ServiceGroupsEntityEffects {
  
  getServiceGroupsFromServer = createEffect(() => this.dataPersistence.fetch(ServiceGroupsEntityActionTypes.GetServiceGroupsFromServer, {
    run: (action: GetServiceGroupsFromServer, state: any) => {
      return this.apiService
        .get<ServiceGroup[]>(`v/1/fixed-operations/service-groups`, {
          params: action.payload
        })
        .pipe(
          map(messageTypes => {
            return new GetServiceGroupsFromServerSuccess(messageTypes);
          })
        );
    },
    onError: (action: GetServiceGroupsFromServer, error) => {
      console.error('Error', error);
    }
  }));

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<any>,
    private apiService: ApiService,
    private router: Router
  ) {}
}
